import React from 'react'
import { Popover} from "@headlessui/react";

export default function BrandingHeader() {
  return (
    <>
      <Popover className="relative bg-white">
        {({ open }) => (
          <>
            <div className="container  mx-auto px-4 sm:px-2 ">
              <div className="flex justify-between items-center border-b-2 border-gray-100 py-6 sm:py-4 md:justify-start  md:space-x-10">
                <div className="flex justify-start lg:w-0 lg:flex-1">
                  <div className="w-max flex items-center">
                    <div>
                      <a
                        className="
                    flex
                    title-font
                    font-medium
                    items-center
                    md:justify-start
                    justify-center
                    text-gray-900
                  "
                        href="/"
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 64 64"
                          fill="none"
                          className="w-7 h-7"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="32" cy="32" r="21.3333" fill="white" />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M7.52941 0C3.37103 0 0 3.37103 0 7.52941V56.4706C0 60.629 3.37103 64 7.52941 64H32C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0H7.52941ZM31.3172 23.377C34.0962 20.5435 38.51 20.0531 41.5069 22.6142C44.9398 25.5567 45.1033 30.7877 42.0518 33.9482L31.4807 44.8463C30.8268 45.5547 29.6825 45.5547 29.0286 44.8463L18.4575 33.9482C15.406 30.7877 15.5695 25.5567 19.0024 22.6142C21.9993 20.0531 26.4676 20.5435 29.1921 23.377L30.2819 24.4668L31.3172 23.377Z"
                            fill="url(#paint0_linear)"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear"
                              x1="-5.90224e-07"
                              y1="-2.61818"
                              x2="52.6545"
                              y2="61.3818"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="#3D98FF" />
                              <stop offset="1" stopColor="#330B66" />
                            </linearGradient>
                          </defs>
                        </svg>
                      </a>
                    </div>
                    <div className="sm:text-3xl text-2xl font-bold text-gray-900 ml-4">
                      Dev Colony
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </Popover>
    </>
  );
}
